import { render, staticRenderFns } from "./TreatmentDetailTemplate.vue?vue&type=template&id=b038c476&scoped=true&"
import script from "./TreatmentDetailTemplate.vue?vue&type=script&lang=ts&"
export * from "./TreatmentDetailTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentDetailTemplate.vue?vue&type=style&index=0&id=b038c476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b038c476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VDialog,VRadio,VRadioGroup,VSelect})
